import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const StatisticBarChart = ({ data }) => {
if(!data){
  return null;
}
console.log("data:>>>>>>>>>>",data)
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const chartData = {
    labels: months,
    datasets: [
      {
        label: 'ຈໍານວນເງີນຕົ້ນທືນທີເກັບຄືນໄດ້',
        backgroundColor: '#4CAF50',
        data: data?.statistic?.map((item) => item.totalPrincipal)
      },
      {
        label: 'ຈໍານວນເງີນກໍາໄລ',
        backgroundColor: '#2196F3',
        data: data?.statistic?.map((item) => item.totalIncome)
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom'
      },
      title: {
        display: true,
        text: `ປະຫັວດຈຳນວນເງິນເກັບຄືນ ເເລະ ກໍາໄລໃນປີ ${data?.year}`
      }
    }
  };

  return <div className='w-100'>
     <Bar data={chartData} options={chartOptions} />
  </div>;
};

export default StatisticBarChart;